import React from 'react'
import cn from 'classnames'
import { CommentType } from '@models/comment/CommentType'
import CommentCard from '../CommentCard'
import { CommentReplyProps } from './interface'

const CommentReply = ({
  comment,
  replyComment,
  likeComment,
  manageComment,
  unHiddenComment,
  replyUser,
  onReplyCommentSubmit,
  user,
  isReadmore,
  handleClickReadmore,
  lastIndex,
  replyCommentBoxRef,
  editCommentId,
  onCancelEditComment,
  onEditCommentSubmit,
  authorUserId,
  isCommentAble,
  isUserHasBlockedComment,
  isDrawer,
  bookId,
  bookTitle,
  isShowBookTitle,
  isNightOrDarkTheme,
  isLightOrSepiaTheme,
}: CommentReplyProps) => {
  return (
    <div className='relative'>
      <div className='relative'>
        <div
          className={cn(
            'absolute left-[25px] top-[45px] border-l-[1px] border-gray-3 h-full mobile:top-[35px]',
            {
              hidden:
                !comment.childrenComment?.length ||
                !isReadmore ||
                !comment.visible,
              'opacity-10': isNightOrDarkTheme,
            }
          )}
        />
        <CommentCard
          comment={comment}
          isReadmore={isReadmore}
          rootId={comment.id}
          replyComment={replyComment}
          likeComment={likeComment}
          manageComment={manageComment}
          isSubComment={false}
          handleClickReadmore={handleClickReadmore}
          unHiddenComment={unHiddenComment}
          replyUser={replyUser}
          onReplyCommentSubmit={onReplyCommentSubmit}
          isReplyCommentBox={!comment.childrenComment.length}
          user={user}
          replyCommentBoxRef={replyCommentBoxRef}
          editCommentId={editCommentId}
          onCancelEditComment={onCancelEditComment}
          onEditCommentSubmit={onEditCommentSubmit}
          authorUserId={authorUserId}
          isCommentAble={isCommentAble}
          isUserHasBlockedComment={isUserHasBlockedComment}
          isDrawer={isDrawer}
          bookId={bookId}
          bookTitle={bookTitle}
          isShowBookTitle={isShowBookTitle}
        />
      </div>
      {isReadmore &&
        comment.visible &&
        comment.childrenComment?.length > 0 &&
        comment.childrenComment?.map((child: CommentType, index: number) => (
          <div key={child.id}>
            <CommentCard
              comment={child}
              isSubComment
              isReadmore={isReadmore}
              rootId={comment.id}
              replyComment={replyComment}
              likeComment={likeComment}
              manageComment={manageComment}
              handleClickReadmore={handleClickReadmore}
              unHiddenComment={unHiddenComment}
              isLastComment={index >= lastIndex}
              replyUser={replyUser}
              onReplyCommentSubmit={onReplyCommentSubmit}
              isReplyCommentBox={comment.childrenComment.length - 1 === index}
              user={user}
              replyCommentBoxRef={replyCommentBoxRef}
              editCommentId={editCommentId}
              onCancelEditComment={onCancelEditComment}
              onEditCommentSubmit={onEditCommentSubmit}
              authorUserId={authorUserId}
              isCommentAble={isCommentAble}
              isDrawer={isDrawer}
              className={cn(
                'w-[100px] mobile:absolute mobile:w-[25px] ml-[25px] mt-[25px] border-t-[1px] mobile:mt-[15px]',
                {
                  'border-none': child.replied,
                  'border-gray-3': isLightOrSepiaTheme,
                  'border-gray-3/10': isNightOrDarkTheme,
                }
              )}
              isUserHasBlockedComment={isUserHasBlockedComment}
            />
          </div>
        ))}
      <div
        className={cn('pt-[20px] border-b-[1px] w-full', {
          'mt-[30px]': isReadmore && comment.visible,
          'border-gray-3': isLightOrSepiaTheme,
          'border-white/10': isNightOrDarkTheme,
        })}
      />
    </div>
  )
}

export default CommentReply
